<template>
    <main class="app-content">
        <div class="app-title">
            <div>
                <h1>
                    <font-awesome-icon icon="phone"/>
                    {{$t('title')}}
                </h1>
            </div>
        </div>
        <number-list></number-list>
    </main>
</template>

<script>
    import NumberList from "./NumberList";

    export default {
        components: {NumberList},
        data: function () {
            return {}                                                                          
        },
        i18n: {
            messages: {
                en: {
                    title: 'Phone numbers list',
                },
                vi: {
                    title: 'Danh sách số điện thoại',
                }
            }
        },
    };
</script>